"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polandTranslations = void 0;
var _types = require("../../../types");
const polandTranslations = exports.polandTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Najmocniej przepraszamy!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Powrót',
  [_types.ErrorPageTranslationKey.text]: 'Niestety strona, którą chcesz otworzyć, jest w tej chwili niedostępna',
  [_types.ErrorPageTranslationKey.notFound]: 'Strona, której szukasz nie została znaleziona',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Nie masz dostępu do strony, którą próbujesz odwiedzić.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Skontaktuj się z zespołem wsparcia Oriflame poprzez e-mail:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Żądany adres URL został odrzucony!'
};
